export default "__VITE_ASSET__8d86b83d__"